/**
 * Проверка контура перед отправкой — общая для формы зоны и окна карты.
 *
 * Живёт отдельно, потому что тянет за собой карту: `@arbuz/ui-map` грузится
 * лениво, и оба экрана должны просить его одинаково, а не каждый по-своему.
 */
import type { GeoJsonPolygon } from '@arbuz/shared';

/**
 * Пересекаются ли линии контура.
 *
 * `CHECK ST_IsValid` в базе такой контур отвергнет, но его ответ ничего не
 * объясняет, а на негодном полигоне `ST_Contains` возвращает мусор — зона
 * начинает накрывать не те адреса.
 */
export async function polygonSelfIntersects(geom: GeoJsonPolygon): Promise<boolean> {
  // Замыкающая точка дублирует первую — на проверку её не подаём
  const ring = geom.coordinates[0]?.slice(0, -1).map(([lon, lat]) => [lat, lon] as [number, number]);
  if (!ring) return false;

  const m = await import('@arbuz/ui-map');
  return m.hasSelfIntersection(ring);
}
